import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';

export default function KardexAuditGuard() {
  const { kardexAuditModuleEnabled, loaded } = useModuleSettings();

  if (!loaded) {
    return <Outlet />;
  }

  if (!kardexAuditModuleEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
